import React from 'react';
import { useTheme } from "styled-components";

export const ChevronUpSvg = (props) => {

  const { width, height, color, applyThemeColor } = props;
  const theme = useTheme();
  const themeColor = `${theme?.colour?.secondary}4D`
  let colorTUse = color ?? window?.settings?.secondary_color ?? "#04333B";
  if (applyThemeColor) {
    colorTUse = themeColor;
  }

  return (
    <svg width={width ?? "11"} height={height ?? "6"} viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path strokeWidth="0.25" d="M1.54023 5.72773C1.19127 6.08873 0.625719 6.08873 0.264727 5.73977C0.0842314 5.55927 0 5.33064 0 5.08998C0 4.86135 0.0842314 4.63273 0.264727 4.46426L4.4402 0.264727C4.60866 0.0962644 4.83729 0 5.07795 0C5.31861 0 5.54724 0.0962644 5.7157 0.264727L9.89117 4.46426C10.2522 4.81322 10.2522 5.37878 9.89117 5.73977C9.54221 6.08873 8.96463 6.08873 8.61567 5.72773L5.07795 2.17798L1.54023 5.72773Z" fill={colorTUse} />
    </svg>
  )
}